import Spinner from "./Spinner";
import React from "react"
import PropTypes from "prop-types"
const Button=({children,rounded="",theme="light",outlined=false,disabled=false,loading=false,className="",onClick,type="button"})=>{
    const btnTheme=`btn-${outlined?"outlined-":""}${theme} ${rounded} `
    return <button  onClick={onClick} type={type}  disabled={disabled || loading} className={`btn focus:outline-none text-center flex justify-center ${btnTheme} ${className}`}>{loading?<Spinner className="text-2xl"/>:children}</button>
}
Button.propTypes = {

    rounded: PropTypes.oneOf(["full","rounded-lg","rounded","rounded-xl","rounded-2xl"]),
    outlined: PropTypes.bool,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    theme: PropTypes.oneOf(["link","light", "blue","red","green","green","dark","purple",'warning']),
    type: PropTypes.oneOf(["button","submit"]),
    className: PropTypes.string}

export default Button